import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Phone, Check } from 'lucide-react';
import { company } from '../mock';

export default function StickyBookBar({ bookHref = '#request-service', bookLabel = 'Request Service', internal = false }) {
  useEffect(() => {
    document.body.classList.add('has-sticky-bar');
    return () => document.body.classList.remove('has-sticky-bar');
  }, []);

  return (
    <div className="sticky-book-bar" data-testid="sticky-book-bar">
      <a className="sbb-btn sbb-call" href={company.phoneHref} data-testid="sticky-call-btn"><Phone size={17} /> Call Now</a>
      {internal
        ? <Link className="sbb-btn sbb-book" to={bookHref} data-testid="sticky-book-btn"><Check size={17} /> {bookLabel}</Link>
        : <a className="sbb-btn sbb-book" href={bookHref} data-testid="sticky-book-btn"><Check size={17} /> {bookLabel}</a>}
    </div>
  );
}
